// extracted by mini-css-extract-plugin
module.exports = {"downloadBtn":"MarkdownToPdf_downloadBtn__IZajt","spinner":"MarkdownToPdf_spinner__AqDEs","spin":"MarkdownToPdf_spin__pimUq"};